<template>
    <jet-dialog-modal
        :show="isOpen" 
        @close="$emit('close')"
        ref="modal"
    >
        <template #title>
            Add New Contact
        </template>

        <template #content>
            <form id="createContactForm" @submit.prevent="submitHandler">
                <div class="tra__message-form sm:flex sm:flex-wrap relative">
                    <div class="sm:w-1/2 sm:pr-2">
                        <label
                            class="w-full block text-gray-700"
                            for="first_name"
                            >First Name</label
                        >
                        <maz-input
                            v-model="form.first_name"
                            name="first_name"
                            placeholder="First Name"
                            class="mb-3 w-full"
                        />
                        <jet-input-error
                            :message="$page.props.errors.first_name"
                            class="mt-2"
                        />
                    </div>
                    <div class="sm:w-1/2 sm:pl-2">
                        <label
                            class="w-full block text-gray-700"
                            for="last_name"
                            >Last Name</label
                        >
                        <maz-input
                            v-model="form.last_name"
                            name="last_name"
                            placeholder="Last Name"
                            class="mb-3 w-full"
                        />
                        <jet-input-error
                            :message="$page.props.errors.last_name"
                            class="mt-2"
                        />
                    </div>
                    <div class="w-full mt-4 mb-4">
                        <label
                            class="w-full block text-gray-700"
                            for="phone-number"
                            >Phone Number</label
                        >
                        <maz-phone-number-input
                            id="phone-number"
                            v-model="form.phone_number"
                            :only-countries="['US']"
                            :required="true"
                            @update="phoneNumberUpdate"
                        />

                        <jet-input-error
                            :message="$page.props.errors.phone_number"
                            class="mt-2"
                        />
                        <div class="error mt-2" v-if="showPhoneNumberValidationError">
                            This phone number does not appear to be valid
                        </div>
                    </div>
                    <div class="w-full mt-4 mb-4">
                        <label class="flex items-center">
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                value="y"
                                v-model="form.contactterms"
                                required
                            />
                            <span class="ml-2 text-sm text-gray-600">
                                I agree to TextSpot's
                                <a href="https://textspot.io/terms"
                                target="_blank"
                                class="text-blue-400 underline" >Terms of Service &amp; Use</a><br>
                                By agreeing, I verify that I've received express consent to message contacts I'm importing.
                            </span>
                        </label>
                    </div>
                </div>
            </form>
        </template>

        <template #footer>
            <button class="mr-4" @click="$emit('close')">
                Cancel
            </button>

            <jet-secondary-button
                type="submit"
                form="createContactForm"
                :disabled="form.processing || !phoneNumberValid"
            >
                Create Contact
            </jet-secondary-button>
        </template>
    </jet-dialog-modal>

</template>

<script>
import JetSecondaryButton from "../Jetstream/SecondaryButton";

import {mapWritableState, mapActions} from 'pinia';
import contactStore from '../Stores/contacts.js';
import { useGeneralTableStore } from '@/Stores/general_table';

export default {
    components: {
        JetSecondaryButton,
    },
    name: "ContactCreateModal",
    emits: ['close', 'contact-created'],
    props: {
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                first_name: null,
                last_name: null,
                phone_number: null,
                contactterms: null
            }),
            phoneNumberValid: false,
            showPhoneNumberValidationError: false,
        };
    },
    mounted() {
        console.log("Contact create modal mounted", this.isOpen);
    },
    methods: {
        ...mapActions(useGeneralTableStore, ['clearData', 'fetchData']),
        submitHandler() {
            this.form.post(route("contacts.create.submit.json"), {
                onSuccess: page => {
                    this.form.reset();
                    try {
                        window.dataLayer.push({
                            event: "contact-created"
                        });
                    } catch (e) {}
                    this.contactsImported = new Date().toString();
                    // Extract contact ID from the response and pass it with the event
                    const contactId = page.props.flash.created_id;
                    this.$emit('contact-created', contactId);
                    this.fetchData(); //update general table if we're on contacts page
                    this.$emit('close');

                },
                onError: error => {
                    console.log(error);
                }
            });
        },
        phoneNumberUpdate(data) {
            this.phoneNumberValid = data.isValid;
            if (!data.formatInternational) return;

            if (data.formatInternational.length >= 12 && !this.phoneNumberValid) {
                this.showPhoneNumberValidationError = true;
            } else {
                this.showPhoneNumberValidationError = false;
            }
        }

    },
    computed: {
        ...mapWritableState(contactStore, ['contactsImported']),
    }
};
</script>

<style scoped>
    .error {
        @apply bg-red-100 text-red-700 px-4 py-3;
    }

</style>
